import { IconFile } from '@tabler/icons-react'

export const PERMISSION_SETS_FILES = {
  id: 'Files',
  description: 'Grant access to open, upload, delete, and manage files.',
  icon: IconFile,
  sections: [
    {
      title: 'permissions',
      permissions: [
        {
          type: 'checkbox',
          label: 'Open, upload, remove, and manage private files',
        },
        {
          type: 'checkbox',
          label: 'Open, upload, remove, and manage community files',
        },
        {
          type: 'checkbox',
          label: 'Open, upload, remove, and manage public files',
        },
      ],
    },
  ],
}
